import { useState, useEffect } from 'react';

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLabels = ['About', 'Services', 'Values', 'Contact'];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 md:px-14 flex items-center justify-between h-[72px]">
        <div className="flex-shrink-0">
          <span className="font-heading text-lg font-semibold tracking-tight text-foreground-950">
            LineEaseTech OU
          </span>
        </div>

        <div className="hidden md:flex items-center gap-2">
          {navLabels.map((label, i) => (
            <span key={label} className="flex items-center gap-2">
              <span className="text-sm font-medium text-foreground-600 tracking-wide whitespace-nowrap cursor-default">
                {label}
              </span>
              {i < navLabels.length - 1 && (
                <span className="text-foreground-300 text-xs select-none">&#9830;</span>
              )}
            </span>
          ))}
        </div>

        <div className="w-[140px] hidden md:block" />
      </div>
    </nav>
  );
}